import getLogoIconClassNames from '../utils/getLogoIconClassNames';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import ObservableOwaUserConfiguration from 'owa-session-store/lib/types/ObservableOwaUserConfiguration';
import outlookLogo from './Image/outlookLogo24.svg';
import React from 'react';
import strings from 'owa-strings/owa-mini-common-strings';
import { getIconClassName } from '@uifabric/styling/lib/index';
import { getPackageBaseUrl } from 'owa-config';
import { MiniIcons } from 'owa-mini-icons';
import { urlResolve } from 'mini-common-utils/lib/utils/urlResolve';
import { useMemo } from 'react';

const styles = require('./SidePaneHeader.scss');
const classNames = require('classnames/bind').bind(styles);

interface SidePaneHeaderProps extends React.HTMLProps<HTMLDivElement> {
    showSettings?: boolean;
    openSettingsCallback?: () => void;
}

const OUTLOOK_ENTERPRISE_LOGO = urlResolve(
    getPackageBaseUrl(),
    'resources/images/EnterpriseLogo.svg'
);

const SidePaneHeader = React.forwardRef(
    (props: SidePaneHeaderProps, ref?: React.RefObject<any>) => {
        const isInConsumer: boolean = useMemo(isConsumer, []);

        const {
            SessionSettings: { UserEmailAddress },
        }: ObservableOwaUserConfiguration = useMemo(getUserConfiguration, []);
        const logoIconClassNames: string[] = getLogoIconClassNames(isInConsumer);

        const { showSettings, openSettingsCallback } = props;

        return (
            <div className={styles.sidePaneHeader}>
                <div className={styles.sidePaneHeaderContentWrapper}>
                    {isInConsumer ? (
                        <img src={outlookLogo} className={classNames(logoIconClassNames)} />
                    ) : (
                        <img
                            src={OUTLOOK_ENTERPRISE_LOGO}
                            className={classNames(logoIconClassNames)}
                        />
                    )}
                    <div className={styles['sidePaneHeader-content']}>
                        <div tabIndex={0} ref={ref} className={styles.email}>
                            {UserEmailAddress}
                        </div>
                        <div className={styles.service}>
                            {isInConsumer ? 'Outlook' : 'Microsoft 365'}
                        </div>
                    </div>
                </div>
                {showSettings && (
                    <i
                        tabIndex={0}
                        role="button"
                        aria-label={strings.settingsButtonAriaLabel}
                        title={strings.settingsButtonAriaLabel}
                        className={classNames(styles.setting, getIconClassName(MiniIcons.Settings))}
                        onClick={openSettingsCallback}
                        onKeyUp={e => {
                            if (e.key !== 'Enter') {
                                return;
                            }
                            openSettingsCallback();
                        }}
                    />
                )}
            </div>
        );
    }
);

export default SidePaneHeader;
